import { create } from 'zustand'

export const useGeneral = create((set,get) => ({
    darkmode: document.body.getAttribute('data-mode'),
    loading: 'idle',
    error: undefined,
    message: '',    
    toggle: ()=>{
        document.body.setAttribute('data-mode', reverse(get().darkmode) )
        set({ darkmode: reverse(get().darkmode) })  
    },
    setMode: (value)=>{
        document.body.setAttribute('data-mode', value)
        set({ darkmode:value })  
    },
  }))


  const reverse = (value) => value=='dark'?'light':'dark'